<template>
  <div class="addBox relative">
    <div class="title">
      <div class="title_left"><span class="movePoin" @click="$router.go(-1)">主体信息维护</span>/<span class="type">编辑</span>
      </div>
    </div>
    <el-form :model="form" :rules="rules" ref="form" label-width="166px">
      <ToggleForm title="概况"  :zoomed='true'>
        <div class="content">
          <div class="row mt20">
            <el-form-item label="名称：">
              <el-input :disabled="true" maxlength="30" class="w300" v-model="form.buyerName"></el-input>
            </el-form-item>
          </div>
          <div class="row mt20">
            <el-form-item label="法人(负责人)：" prop="legalPerson">
              <el-input placeholder="请输入法人(负责人)姓名" maxlength="30" class="w300" v-model="form.legalPerson"></el-input>
            </el-form-item>
          </div>
          <div class="row mt20">
            <el-form-item label="地址：" prop="address">
              <el-input placeholder="请输入地址" maxlength="100" class="w300" v-model="form.address"></el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="量化等级：">
              <p class="rowybUploadText w500">量化等级不能编辑，如系统量化等级不准确，需要更改，请联系：19900009999</p>
              <el-input class="w300" v-model="form.qualityLevel" :disabled="true"></el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="风险分级：">
              <p class="rowybUploadText w500">风险分级不能编辑，如系统风险分级不准确，需要更改，请联系：19900009999</p>
              <el-input class="w300" v-model="form.riskLevel" :disabled="true"></el-input>
            </el-form-item>
          </div>
          <div class="row rowybUpload">
            <el-form-item label="头像：">
              <p class="rowybUploadText w500">头像仅用于展示，推荐长宽比为1:1，图片分辨率：600*600像素以上</p>
              <urlUpload :maxLength=1 v-if='show' @uploadSuccess='getFiles' @uploadError="getFiles" @remove='getFiles'
                :filesArr='filesArr'></urlUpload>
              <!-- filesArr:[],回显的时候必传 -->
            </el-form-item>
          </div>
        </div>
      </ToggleForm>
      <ToggleForm title="简介" :zoomed='true'>
        <div class="content">
          <div class="row mt20">
            <el-form-item label="简介：" prop="rr">
              <el-input type="textarea" class="w300" :autosize="{ minRows: 5, maxRows: 10}" placeholder="请输入简介" maxlength="300"
                v-model="form.profile"></el-input>
            </el-form-item>
          </div>
        </div>
      </ToggleForm>
      <ToggleForm title="经营信息"  :zoomed='true'>
        <div class="content manage-content">
          <div class="row mt20">
            <el-form-item label="经营面积：">
              <el-input  maxlength="30" class="w200" placeholder="请输入经营面积" v-model="form.cover"><i slot="suffix" style="font-style:normal" class="metre">㎡</i></el-input>
            </el-form-item>
          </div>
          <div class="row ">
            <el-form-item label="经营场所：" prop="workspace">
              <el-input placeholder="请输入经营场所" maxlength="100" class="w300" v-model="form.workspace"></el-input>
            </el-form-item>
          </div>
          <div class="row ">
            <el-form-item label="GPS地址：" prop="gpsAddress">
              <el-input placeholder="请输入地址" maxlength="100" @keyup.enter.native="getCoordinate" class="w300" v-model="form.gpsAddress"></el-input>
            </el-form-item>
            <el-button type="primary" @click="getCoordinate" style="margin-left:10px">获取经纬度</el-button>
          </div>
          
          <div class="row ">
            <el-form-item label="经度：" prop="lng">
              <el-input placeholder="请输入经度" maxlength="100" class="w250" v-model="form.lng"></el-input>
            </el-form-item>
         
            <el-form-item label="纬度：" prop="lat">
              <el-input placeholder="请输入纬度" maxlength="100" class="w250" v-model="form.lat"></el-input>
            </el-form-item>
          </div>
          <div class="row ">
            <el-form-item label="行业类型：" prop="buyerType">
              <el-select v-model="form.buyerType" clearable placeholder="请选择行业类型">
                <el-option v-for="item in buyerType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
	          	</el-select>
            </el-form-item>
         
            <el-form-item label="学校类型：" prop="scType">
              <el-select v-model="form.scType" :disabled="isScTypeDisabled" clearable placeholder="请选择学校类型">
                <el-option v-for="item in scType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
	          	</el-select>
            </el-form-item>
          </div>
          <div class="row ">
            <el-form-item label="营业状态：" prop="workStatus">
               <el-select v-model="form.workStatus" clearable placeholder="请选择营业状态">
                <el-option v-for="item in workStatus" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
	          	</el-select>
            </el-form-item>
         
            <el-form-item label="从业人数：" prop="empNumber">
              <el-input placeholder="请输入从业人数" maxlength="30" class="w200" v-model="form.empNumber"></el-input>
            </el-form-item>
          </div>
          <div class="row ">
            <el-form-item label="主体业态：" prop="entityType">
              <el-select v-model="form.entityType" clearable placeholder="请选择主体业态">
                <el-option v-for="item in entityType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
	          	</el-select>
            </el-form-item>
         
            <el-form-item label="是否提供网络外卖服务：" prop="takeOut">
              <el-select v-model="form.takeOut" clearable placeholder="是否提供网络外卖服务">
                <el-option v-for="item in takeOut" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
	          	</el-select>
            </el-form-item>
          </div>
          <div class="row ">
            <el-form-item label="网络经营：" prop="onlineType">
              <el-select v-model="form.onlineType" clearable placeholder="请选择网络经营类型">
                <el-option v-for="item in onlineType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
	          	</el-select>
            </el-form-item>
          </div>
        </div>
      </ToggleForm>
      <ToggleForm title="证照信息" :zoomed='true'>
        <div class="content">
          <div class="row rowybUpload">
            <el-form-item label="营业执照：">
              <p class="rowybUploadText w500">营业执照用于公示，只支持jpg/png/gif格式，大小不超过10M，建议尺寸为：800*600</p>
              <urlUpload :maxLength=1 v-if='show' @uploadSuccess='getFiles1' @uploadError="getFiles1" @remove='getFiles1'
                :filesArr='filesArr1'></urlUpload>
              <!-- filesArr:[],回显的时候必传 -->
            </el-form-item>
          </div>
          <div class="row mt20">
            <el-form-item label="营业执照编号：" prop="creditCode" class="clear_a">
              <el-input placeholder="请输入营业执照编号" maxlength="30" class="w300" v-model="form.creditCode"></el-input>
            </el-form-item>
          </div>
          <div class="row rowybUpload">
            <el-form-item label="许可证：" prop="licenceImgUrl">
              <p class="rowybUploadText w500">许可证用于公示，只支持jpg/png/gif格式，大小不超过10M，建议尺寸为：800*600</p>
              <urlUpload :maxLength=1 v-if='show' @uploadSuccess='getFiles2' @uploadError="getFiles2" @remove='getFiles2'
                :filesArr='filesArr2'></urlUpload>
              <!-- filesArr:[],回显的时候必传 -->
            </el-form-item>
          </div>
          <div class="row mt20">
            <el-form-item label="许可证编号：" prop="licence" class="clear_a">
              <el-input placeholder="请输入许可证编号" maxlength="30" class="w300" v-model="form.licence"></el-input>
            </el-form-item>
          </div>
          <div class="row mt20">
            <el-form-item label="许可证截止有效期：" prop="licenceExpdate" class="clear_a">
              <el-date-picker class="w300" v-model="form.licenceExpdate" type="date" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :editable="false" :clearable="true" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
        </div>
      </ToggleForm>
      <ToggleForm title="荣誉" :zoomed='true'>
        <div class="content">
          <div class="row mt20">
            <el-form-item label="荣誉奖项：" prop="rr">
              <el-input type="textarea" class="w300" :autosize="{ minRows: 5, maxRows: 10}" placeholder="请输入荣誉奖项" maxlength="300"
                v-model="form.honour"></el-input>
            </el-form-item>
          </div>
          <div class="row rowybUpload">
            <el-form-item label="图片：">
              <p class="rowybUploadText w500">推荐长宽比为1:1，图片分辨率：600*600像素以上，最多10张</p>
              <ybUpload :maxLength=10 v-if='show' @uploadSuccess='getFiles3' @uploadError="getFiles3" @remove='getFiles3'
                :filesArr='filesArr3'></ybUpload>
              <!-- filesArr:[],回显的时候必传 -->
            </el-form-item>
          </div>
        </div>
      </ToggleForm>
      <ToggleForm title="主体图片" :zoomed='true'>
        <div class="content">
          <div class="row rowybUpload">
            <el-form-item label="主体图片：">
              <p class="rowybUploadText w500">推荐长宽比为1:1，图片分辨率：600*600像素以上，最多10张</p>
              <ybUpload :maxLength=10 v-if='show' @uploadSuccess='getFiles4' @uploadError="getFiles4" @remove='getFiles4'
                :filesArr='filesArr4'></ybUpload>
              <!-- filesArr:[],回显的时候必传 -->
            </el-form-item>
          </div>
        </div>
      </ToggleForm>
    </el-form>
    <div class="foot-btn">
      <div>
        <el-button class="w70 mr10" @click="$router.go(-1)">取消</el-button>
        <el-button type="primary w70" :disabled="btn" @click="submit">保存</el-button>
      </div>
    </div>
     <el-dialog class="dialogDiv" top="5vh" v-if="mapDialogVisible" :visible.sync="mapDialogVisible" :close-on-click-modal="false" title="获取经纬度" style="padding-top: 0px;">
        <el-form :model="mapData" :rules="mapDataRules" :inline="true" ref="mapData" label-position="right">
            <div class="form-item">
                <el-form-item label="地址：" prop="address">
                    <span>{{mapData.address}}</span>
                </el-form-item>
                <el-form-item label="经度：" class="ml20" prop="lng">
                    <span>{{mapData.lng}}</span>
                </el-form-item>
                <el-form-item label="纬度：" class="ml20" prop="lat">
                    <span>{{mapData.lat}}</span>
                </el-form-item>
            </div>
            <div id="container"></div>
        </el-form>
        <div class="footer">
            <el-button @click="cancleMap" round>关闭</el-button>
            <el-button type="primary" @click="submitMap('pwdData')" round>保存</el-button>
        </div>
    </el-dialog>
  </div>
  
</template>


<script>
  import ToggleForm from "components/ToggleForm";
  import urlUpload from "components/urlUpload";
  import ybUpload from "components/ybUpload";
  import * as api from "api/personApi";
  var geocoder;
  var marker;
  var map;
  export default {
    name: "schoolEdit",
    components: {
      ToggleForm,
      urlUpload,
      ybUpload
    },
    computed:{
      isScTypeDisabled: function() {
      return ['KINDSC', 'PRISC', 'MIDSC', 'HIGSC', 'UNVSC', ''].indexOf(this.form.buyerType) === -1 ? true : false
    },
    },
    data() {
      return {
        show: false,
        btn: false,
        mapDialogVisible:false,
        mapData: {
        address: '',
        lng: '',
        lat: ''
        },
        mapDataRules: {

        },
        workStatus: [
        {value:1,label:'正常营业'},
        {value:2,label:'暂停营业'},
        {value:3,label:'停止营业'},
      ],
      onlineType:[
        {value:1,label:'美团'},
        {value:2,label:'饿了么'},
      ],
      takeOut:[
        {value:1,label:'是'},
        {value:2,label:'否'},
      ],
      entityType:[
        {value:1,label:'小吃店'},
        {value:2,label:'快餐店'},
        {value:3,label:'小型餐饮'},
        {value:4,label:'中型餐饮'},
        {value:5,label:'大型餐饮'},
        {value:6,label:'特大型餐饮'},
        {value:7,label:'饮品店（含甜品站）'},
        {value:8,label:'集体用餐配送单位'},
        {value:9,label:'中央厨房'},
        {value:10,label:'学校（含托幼机构）食堂'},
        {value:11,label:'机关企事业单位食堂'},
        {value:12,label:'工地食堂'},
        {value:13,label:'其他食堂'},
      ],
      scType: [
        {value:'PUBLIC',label:'公立'},
        {value:'PRIVATE',label:'私立'},
    ],
    buyerType: [
       {value:'KINDSC',label:'幼儿园'},
       {value:'PRISC',label:'小学'},
       {value:'MIDSC',label:'初中'},
       {value:'HIGSC',label:'高中'},
       {value:'UNVSC',label:'大学'},
       {value:'HSPT',label:'医院'},
       {value:'CORP',label:'企事业单位'},
       {value:'GOV',label:'政府机关'},
       {value:'RSTNT',label:'社会餐饮'},
       {value:'SPMKT',label:'商超'},
       {value:'HOTEL',label:'酒店'},
       {value:'WSMKT',label:'批发'},
       {value:'FMMKT',label:'农贸'},
       {value:'PERSON',label:'个体'},
       {value:'CIRCULATION',label:'流通主体'},
       {value:'NURSING_HOME',label:'养老院'},
       {value:'XJBT',label:'新疆生产建设兵团'},
    ],
        options:[],
        filesArr: [],
        filesArr1: [],
        filesArr2: [],
        filesArr3: [],
        filesArr4: [],
        rules: {
          legalPerson: [{
            required: true,
            message: "负责人姓名必填，并且必须是30字以内",
            trigger: "blur"
          }],
          address: [{
            required: true,
            message: "地址必填，并且必须是100字以内",
            trigger: "blur"
          }],
          licenceExpdate: [{
            required: true,
            message: "请输入许可证截止有效期",
            trigger: "blur"
          }],
          licenceImgUrl:[{
            required: true,
            message: "请上传许可证",
            trigger: "blur"
          }],
          workspace:[{
            required: true,
            message: "请输入经营场所",
            trigger: "blur"
          }],
          gpsAddress:[{
            required: true,
            message: "请输入GPS地址",
            trigger: "blur"
          }],
          lng:[{
            required: true,
            message: "请输入经度",
            trigger: "blur"
          }],
          lat:[{
            required: true,
            message: "请输入纬度",
            trigger: "blur"
          }],
          buyerType:[{
            required: true,
            message: "请选择行业类型",
            trigger: "change"
          }],
        },
        // licenceImgUrl: [],//许可证
        // creditImgUrl: [],//营业执照
        // profileimgUrl: [],//头像
        // honourImages:[],//荣誉奖项
        // entityImages:[],//主体图片
        form: {
          legalPerson: "",
          address: "",
          qualityLevel: '',
          licenceExpdate: "",
          licence:'',
          licenceImgUrl: '',
          creditImgUrl: '',
          creditCode:'',
          profileimgUrl: '',
          profile:'',
          honour:'',
          honourImages: [],
          entityImages: []
        },
        baseUrl: this.$store.state.common.baseUrl,
      };
    },
    methods: {
      // 地图弹框
    getCoordinate() {
      if(!this.form.gpsAddress) {
        this.$message.warning('GPS地址为空，无法获取')
        return
      }
      this.mapDialogVisible = true
      this.locate()
      this.mapShowFun()
    },
    cancleMap() {
      this.mapDialogVisible = false
    },
    submitMap(mapData) {
      // TODO 经纬度格式校验
      this.form.gpsAddress = this.mapData.address
      this.form.lng = this.mapData.lng
      this.form.lat = this.mapData.lat
      this.mapDialogVisible = false
    },
    locate() {
      let that = this;
      AMap.plugin('AMap.Geocoder', function() {
          geocoder = new AMap.Geocoder()
          geocoder.getLocation(that.form.gpsAddress, function(status, result) {
              if (status === 'complete' && result.info === 'OK') {
                  // result中对应详细地理坐标信息
                  let lng = result.geocodes[0].location.lng;
                  let lat = result.geocodes[0].location.lat;
                  that.mapData.address = result.geocodes[0].formattedAddress;
                  that.mapData.lng = parseFloat(lng).toFixed(6)
                  that.mapData.lat = parseFloat(lat).toFixed(6)

                  map.setZoomAndCenter(15, [result.geocodes[0].location.lng, result.geocodes[0].location.lat]);
                  that.addMarker(result.geocodes[0].location.lng, result.geocodes[0].location.lat);
              } else {
                  that.mapData.address = '四川省成都市'
                  that.mapData.lng = 104.066541
                  that.mapData.lat = 30.572269
                  that.$message.warning('GPS地址无法解析! 请输入正确的地址或点击地图获取')
              }
          })
      })
    },
      mapShowFun() {
        setTimeout(() => {
            map = new AMap.Map('container', {
                resizeEnable: true, //是否监控地图容器尺寸变化
            });
            let that = this;
            AMap.event.addListener(map, 'click', function (e) { //添加点击事件,传入对象名，事件名，回调函数
                if(marker) {
                    map.remove(marker);
                }
                AMap.plugin('AMap.Geocoder', function() {
                    geocoder = new AMap.Geocoder({})
                    var lnglat = [e.lnglat.getLng(), e.lnglat.getLat()]
                    geocoder.getAddress(lnglat, function(status, result) {
                        if (status === 'complete' && result.info === 'OK') {
                          map.setCenter(e.lnglat);
                          // result为对应的地理位置详细信息
                          let lng = e.lnglat.getLng();
                          let lat = e.lnglat.getLat();
                          that.mapData.address = result.regeocode.formattedAddress;
                          that.mapData.lng = parseFloat(lng).toFixed(6);
                          that.mapData.lat = parseFloat(lat).toFixed(6);
                        }
                    })
                })
                that.addMarker(e.lnglat.getLng(), e.lnglat.getLat());
                map.setFitView();
            })
        }, 100)
      },
    addMarker(lng, lat) {
      let icon = new AMap.Icon({
          size: new AMap.Size(30, 40),    // 图标尺寸
          image: 'http://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',  // Icon的图像
          imageOffset: new AMap.Pixel(0, 0),  // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(30, 40)   // 根据所设置的大小拉伸或压缩图片
      });
      marker = new AMap.Marker({
          icon: icon,
          position: [lng, lat],
          offset: new AMap.Pixel(-10, -40)
      });
      marker.setMap(map);
      marker.setAnimation('AMAP_ANIMATION_DROP');
    },
      getFiles4(files, state) {
        this.filesArr4 = files
      },
      getFiles3(files, state) {
         this.filesArr3 = files
      },
      getFiles2(files, state) {
        this.filesArr2 = files
      },
      getFiles1(files, state) {
        this.filesArr1 = files
      },
      getFiles(files, state) {
        this.filesArr = files
      },
      submit(type) {
        if (this.filesArr2.length <= 0) {
          this.$message.error('请上传许可证');
          return
        } else {
          this.form.licenceImgUrl = this.filesArr2[0].url
        }
        this.form.creditImgUrl = this.filesArr1.length > 0?this.filesArr1[0].url:''
        this.form.profileimgUrl = this.filesArr.length > 0? this.filesArr[0].url:''
        this.form.honourImages=this.filesArr3.map(obj=>obj.fileId)
        this.form.entityImages=this.filesArr4.map(obj=>obj.fileId)
        this.btn = true;
        this.$refs["form"].validate(valid => {
          if (valid) {
            this.$confirm("是否确认提交修改？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
              .then(() => {
                api.xcwsEntityExtUpdate(this.form).then(r => {
                  if (r.code == 200) {
                    this.$message({
                      message: "修改成功，正在返回主体信息维护页",
                      type: "success"
                    });
                    setTimeout(() => {
                      this.$router.go(-1);
                    }, 1500);
                  }
                  this.btn = false;
                });
              })
              .catch(() => {
                this.btn = false;
              });
          } else {
            this.btn = false;
          }
        });
      },
    },
    async mounted() {
      await api.xcwsEntityExt().then(r => {
        if (r.code == 200) {
          this.form = r.data;
          if (!this.form.workStatus) {
            this.form.workStatus = ''
          }
          if (!this.form.onlineType) {
            this.form.onlineType = ''
          }
          if (!this.form.takeOut) {
            this.form.takeOut = ''
          }
          if (!this.form.entityType) {
            this.form.entityType = ''
          }
          if (this.form.profileImgUrl) {
            this.filesArr[0] = {
              name: 'profileImgUrl',
              fileId: '123456',
              url: this.form.profileImgUrl
            }
          }
          if (this.form.licenceImgUrl) {
            this.filesArr2[0] = {
              name: 'licenceImgUrl',
              fileId: '12340056',
              url: this.form.licenceImgUrl
            }
          }
          if (this.form.creditImgUrl) {
            this.filesArr1[0] = {
              name: 'creditImgUrl',
              fileId: '12349956',
              url: this.form.creditImgUrl
            }
          }
          this.show = true
          this.form.honourImages.map(item=>{
            let obj={
              url:this.baseUrl + "/" + item.fileUrl,
              fileId:item.fileId
            }
            this.filesArr3.push(obj);
          })
          this.form.entityImages.map(item=>{
            let obj={
              url:this.baseUrl + "/" + item.fileUrl,
              fileId:item.fileId
            }
            this.filesArr4.push(obj);
          })
        }
      })
    }
  };
</script>

<style scoped lang='scss'>

  .addBox {
    width: calc(100% - 40px);
    min-height: 100%;
    padding: 0 20px 100px 20px;

    .title {
      height: 60px;
      line-height: 60px;

      .title_left {
        font-size: 20px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        width: 50%;
        height: 100%;

        .type {
          color: #70ce97;
        }
      }
    }
    .metre{
      margin-right: 10px;
    }
    .manage-content .row{
      margin-left: calc((100% - 1000px) / 2);
      min-width: 750px;
      .el-form-item{
        .el-form-item__label{
        min-width: 175px !important;
      }
      }
    }
  }
  .dialogDiv::v-deep .el-dialog {
    width: 1000px;
  }
  .dialogDiv{
    .footer {
    text-align: right;
  }
    #container {
    margin-bottom: 20px;
    width: 960px;
    height: 400px;
    }
  }
</style>